// eslint-disable-next-line no-shadow
export enum BaseTextFieldVariant {
	STANDARD = 'standard',
	OUTLINED = 'outlined',
	FILLED = 'filled',
}
